const themeOption = "THEME_OPTION";

const handleAppSetTheme = (state, action) => {
    let newState = { ...state };
    newState.theme = action.payload;
    localStorage.setItem( themeOption , action.payload);
    return newState;
};

const handleAppSwitchTheme = (state) => {
    let newState = { ...state };
    if (newState.theme === "App--light") {
        newState.theme = "none";
    } else {
        newState.theme = "App--light";
    }
    localStorage.setItem( themeOption, newState.theme);
    return newState;
};

export const appReducer = (state = { theme: "none" }, action) => {
    switch (action.type) {
        case "APP_SET_THEME":
            return handleAppSetTheme(state, action);
        case "APP_SWITCH_THEME":
            return handleAppSwitchTheme(state);
        default:
            return state;
    }
};
